import _ from 'lodash';
//constants
import { Ifield, validationProps, validationTypes } from './types';
import { EMAIL_REGEX, PHONE_REGEX } from 'constants/global.constants';

export function loopValidateTypes(name: string, fieldValidations: validationTypes[] = [], value = '') {
	let isValid = { name: name, valid: true, errorText: '' };

	fieldValidations.forEach((type) => {
		switch (type) {
			case validationTypes.requierd:
				if (value === '' || _.isNil(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'This field is required',
					};
				}
				break;
			case validationTypes.lettersOnly:
				if (value && value !== '') {
					const matchLetters = /^([a-z]|\s)+$/i;
					isValid = _.isNil(value.match(matchLetters))
						? {
								...isValid,
								valid: false,
								errorText: 'Text can include only alphabets',
						  }
						: isValid;
				}
				break;
			case validationTypes.email:
				if (!EMAIL_REGEX.test(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'not an email address',
					};
				}
				break;
			case validationTypes.phone:
				if (!PHONE_REGEX.test(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'not a phone',
					};
				}
				break;
			case validationTypes.match:
				if (value === 'false') {
					isValid = {
						...isValid,
						valid: false,
						errorText: "this field doesn't match",
					};
				}
				break;
			case validationTypes.id:
				const intValue = parseInt(value);
				if (isNaN(intValue) || intValue < 1) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'This field is required',
					};
				}
				break;
			case validationTypes.balance:
				const balance = parseFloat(value);
				if (isNaN(balance) || balance < 1) {
					isValid = { ...isValid, valid: false, errorText: 'Minimum of 1 is required' };
				}
				break;
		}
	});
	return isValid;
}

export function validateFields(
	fieldsValidation: { [key: string]: validationTypes[] },
	data: { [key: string]: string }
) {
	let invalidsFields: { [key: string]: validationProps } = {};
	_.keys(fieldsValidation).forEach((name) => {
		if (_.has(data, name)) {
			const isValid = loopValidateTypes(name, fieldsValidation[name], data[name]);
			if (!isValid.valid) {
				invalidsFields = { ...invalidsFields, [isValid.name]: isValid };
			}
		}
	});
	return invalidsFields;
}

export function validateField(field: Ifield, value: string) {
	const isValid = { valid: true, errorText: '' };
	if (!_.has(field, 'validation')) {
		return isValid;
	}
	return loopValidateTypes(field.props.name, field.validation, value);
}

export function setListOfInvalids(
	invalidFields: { [key: string]: validationProps },
	fieldsValidations: { [key: string]: validationTypes[] },
	name: string,
	value: string
) {
	if (_.has(fieldsValidations, name)) {
		const isValid = loopValidateTypes(name, _.get(fieldsValidations, name), value);
		if (!isValid.valid) {
			return { ...invalidFields, [isValid.name]: isValid };
		} else {
			if (_.has(invalidFields, isValid.name)) {
				return _.omit(invalidFields, isValid.name);
			}
		}
	}
	return invalidFields;
}
